/** @format */

import { newPlatformResellerConstants } from './actions';
import { notificationConstants } from '../notifications/notifications';
import { reducerDebug } from '../../core/debug';
import { PlatformResellerCollectionInterface } from '../../interfaces/collections/PlatformResellerCollectionInterface';
import PlatformResellerInterface from '../../interfaces/platform/PlatformResellerInterface';

export type newPlatformResellerReducersType = {
    type: string;
    resellerList?: PlatformResellerCollectionInterface;
    item?: PlatformResellerInterface;
    data?: PlatformResellerInterface;
    success?: boolean;
    deletedSuccess?: boolean;
    message?: string;
    selectedParentReseller?: PlatformResellerInterface;
    mainReseller?: PlatformResellerInterface;
};

export function newPlatformResellerReducers(state = {}, action: newPlatformResellerReducersType): object {
    reducerDebug('new PlatformReseller reducer: ' + action.type);
    switch (action.type) {
        case newPlatformResellerConstants.NEW_PLATFORM_RESELLER_LIST:
        case newPlatformResellerConstants.NEW_PLATFORM_RESELLER_SELECTED_LIST:
        case newPlatformResellerConstants.NEW_PLATFORM_RESELLER_ITEM:
        case newPlatformResellerConstants.NEW_PLATFORM_RESELLER_ADD:
        case newPlatformResellerConstants.NEW_PLATFORM_RESELLER_EDIT:
        case newPlatformResellerConstants.NEW_PLATFORM_RESELLER_DELETE:
        case notificationConstants.ERROR:
            return {
                ...state,
                ...action,
            };
        default:
            return {
                ...state,
            };
    }
}
